import script from "./UploadAddModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadAddModal.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/addUpload.css?vue&type=style&index=0&id=7a08b709&scoped=true&lang=css&external"
import "./UploadAddModal.vue?vue&type=style&index=1&id=7a08b709&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a08b709"]])

export default __exports__